import React from "react";
import { useFormikContext } from "formik";
import { ServiceabilityLocationSelector } from "./ServiceabilityLocationSelector";
import { useFormikFieldState } from "newui/components/ui/CommonSelects/useFormikField";
import type { ServiceabilityLocationSelectorProps } from "./ServiceabilityLocationSelector";

type Props = Omit<ServiceabilityLocationSelectorProps, "value" | "onChange" | "hasError" | "errorText"> & {
	name: string;
};

export const FormikServiceabilitySelector: React.FC<Props> = ({ name, ...rest }) => {
	const { values, setFieldValue, setFieldTouched } = useFormikContext<Record<string, any>>();
	const { hasError, errorText } = useFormikFieldState(name);

	const handleChange = (ids: number[]) => {
		setFieldTouched(name, true, false);
		setFieldValue(name, ids, true);
	};

	return (
		<ServiceabilityLocationSelector
			name={name}
			value={values[name] || []}
			onChange={handleChange}
			hasError={hasError}
			errorText={errorText}
			{...rest}
		/>
	);
};
